export function getCustomerName(
  customer:
    | {
        type: string;
        salutation: string | null | undefined;
        firstName: string | null | undefined;
        lastName: string | null | undefined;
        companyName: string | null | undefined;
      }
    | null
    | undefined
): string {
  if (customer == null) {
    return '---';
  }
  if (customer.type === 'PERSON') {
    if (customer.firstName && customer.lastName) {
      return customer.firstName + ' ' + customer.lastName;
    } else if (customer.lastName && customer.salutation) {
      return customer.salutation + ' ' + customer.lastName;
    } else if (customer.lastName) {
      return customer.lastName;
    } else if (customer.firstName) {
      return customer.firstName;
    } else {
      // Fallback
      return '---';
    }
  } else {
    if (customer.companyName) {
      return customer.companyName;
    } else {
      // Fallback
      return '---';
    }
  }
}

export function getCustomerContactPersonName(
  customerContactPerson:
    | {
        salutation: string | null | undefined;
        firstName: string | null | undefined;
        lastName: string | null | undefined;
      }
    | null
    | undefined
): string {
  if (customerContactPerson == null) {
    return '---';
  }
  if (customerContactPerson.firstName && customerContactPerson.lastName) {
    return customerContactPerson.firstName + ' ' + customerContactPerson.lastName;
  } else if (customerContactPerson.lastName && customerContactPerson.salutation) {
    return customerContactPerson.salutation + ' ' + customerContactPerson.lastName;
  } else if (customerContactPerson.lastName) {
    return customerContactPerson.lastName;
  } else if (customerContactPerson.firstName) {
    return customerContactPerson.firstName;
  } else {
    // Fallback
    return '---';
  }
}
